export default "__VITE_ASSET__Cgav93JA__"